import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8e6699aa"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1))
const _hoisted_2 = {
  key: 0,
  class: "flex flex-col justify-center items-center h-full min-h-screen"
}
const _hoisted_3 = {
  key: 1,
  class: "flex flex-col bg-gray w-full items-center h-full min-h-screen"
}
const _hoisted_4 = { class: "w-full bg-white mb-4" }
const _hoisted_5 = { class: "flex flex-row justify-between" }
const _hoisted_6 = { class: "flex flex-row px-4 py-4 items-center" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "h-8 w-8 text-primary",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, [
  /*#__PURE__*/_createElementVNode("line", {
    x1: "19",
    y1: "12",
    x2: "5",
    y2: "12"
  }),
  /*#__PURE__*/_createElementVNode("polyline", { points: "12 19 5 12 12 5" })
], -1))
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = {
  key: 0,
  class: "job-title"
}
const _hoisted_10 = {
  key: 1,
  class: "job-title"
}
const _hoisted_11 = {
  key: 2,
  class: "job-title"
}
const _hoisted_12 = { class: "flex flex-row px-4 py-4" }
const _hoisted_13 = { class: "mr-3" }
const _hoisted_14 = ["disabled"]
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "h-6 w-6 text-primary mr-2",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, [
  /*#__PURE__*/_createElementVNode("line", {
    x1: "19",
    y1: "12",
    x2: "5",
    y2: "12"
  }),
  /*#__PURE__*/_createElementVNode("polyline", { points: "12 19 5 12 12 5" })
], -1))
const _hoisted_16 = /*#__PURE__*/_createTextVNode(" Previous ")
const _hoisted_17 = [
  _hoisted_15,
  _hoisted_16
]
const _hoisted_18 = /*#__PURE__*/_createTextVNode(" Continue ")
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "h-6 w-6 text-primary ml-2",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "#ffffff",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, [
  /*#__PURE__*/_createElementVNode("line", {
    x1: "5",
    y1: "12",
    x2: "19",
    y2: "12"
  }),
  /*#__PURE__*/_createElementVNode("polyline", { points: "12 19 19 12 12 5" })
], -1))
const _hoisted_20 = [
  _hoisted_18,
  _hoisted_19
]
const _hoisted_21 = ["disabled"]
const _hoisted_22 = {
  key: 0,
  class: "h-6 w-6 text-primary ml-2",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "#ffffff",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("line", {
  x1: "5",
  y1: "12",
  x2: "19",
  y2: "12"
}, null, -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("polyline", { points: "12 19 19 12 12 5" }, null, -1))
const _hoisted_25 = [
  _hoisted_23,
  _hoisted_24
]
const _hoisted_26 = ["disabled"]
const _hoisted_27 = {
  key: 0,
  class: "h-6 w-6 text-primary ml-2",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "#ffffff",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("line", {
  x1: "5",
  y1: "12",
  x2: "19",
  y2: "12"
}, null, -1))
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("polyline", { points: "12 19 19 12 12 5" }, null, -1))
const _hoisted_30 = [
  _hoisted_28,
  _hoisted_29
]
const _hoisted_31 = { class: "flex flex-row items-center justify-start divide-x divide-gray-100" }
const _hoisted_32 = { class: "py-2 px-2 mx-auto bg-white space-y-2" }
const _hoisted_33 = { class: "space-y-0.5" }
const _hoisted_34 = { class: "flex flex-row" }
const _hoisted_35 = { class: "flex bg-primary w-7 h-7 p-1 text-white items-center justify-center rounded-full" }
const _hoisted_36 = { class: "text-gray 700 font-semibold text-medium px-3" }
const _hoisted_37 = { class: "font-sm text-gray-600 py-3" }
const _hoisted_38 = { class: "stepper-pane bg-white p-6 rounded-2xl w-3/4 mb-12" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "stepper-title" }, "General information", -1))
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "stepper-section-title" }, "Personal information", -1))
const _hoisted_41 = { class: "flex flex-col lg:flex-row justify-between items-center lg:space-x-12 space-y-3 lg:space-y-0" }
const _hoisted_42 = { class: "w-full" }
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex flex-row items-center space-x-2 text-base py-1" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "font-thin" }, "First name"),
  /*#__PURE__*/_createElementVNode("span", { class: "text-orange-400" }, "(Required)")
], -1))
const _hoisted_44 = { class: "w-full" }
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex flex-row items-center space-x-2 text-base py-1" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "font-thin" }, "Last name"),
  /*#__PURE__*/_createElementVNode("span", { class: "text-orange-400" }, "(Required)")
], -1))
const _hoisted_46 = { class: "flex flex-col lg:flex-row justify-between items-center lg:space-x-12 space-y-3 lg:space-y-0" }
const _hoisted_47 = { class: "w-full" }
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex flex-row items-center space-x-2 text-base py-1" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "font-thin" }, "Email"),
  /*#__PURE__*/_createElementVNode("span", { class: "text-orange-400" }, "(Required)")
], -1))
const _hoisted_49 = { class: "w-full" }
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex flex-row items-center space-x-2 text-base py-1" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "font-thin" }, "Phone"),
  /*#__PURE__*/_createElementVNode("span", { class: "text-orange-400" }, "(Required)")
], -1))
const _hoisted_51 = { class: "flex flex-col lg:flex-row justify-between items-center lg:space-x-12 space-y-3 lg:space-y-0" }
const _hoisted_52 = { class: "w-full" }
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex flex-row items-center space-x-2 text-base py-1" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "font-thin" }, "Address")
], -1))
const _hoisted_54 = { class: "w-full" }
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("div", { class: "stepper-section-title" }, "Profile")
], -1))
const _hoisted_56 = { class: "flex flex-col" }
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "py-3 text-base font-semibold" }, "Summary", -1))
const _hoisted_58 = { class: "w-full" }
const _hoisted_59 = { class: "py-2" }
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1))
const _hoisted_61 = { class: "py-2" }
const _hoisted_62 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mt-4 mb-3" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "stepper-section-title mr-2" }, [
    /*#__PURE__*/_createTextVNode(" Resume "),
    /*#__PURE__*/_createElementVNode("span", { class: "text-orange-400" }, "(Required)")
  ])
], -1))
const _hoisted_63 = { key: 0 }
const _hoisted_64 = { class: "relative p-3 bg-gray-100 flex flex-row items-center rounded-lg" }
const _hoisted_65 = /*#__PURE__*/_createStaticVNode("<span data-v-8e6699aa><svg class=\"h-8 w-8 text-primary\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" stroke-width=\"2\" stroke=\"currentColor\" fill=\"none\" stroke-linecap=\"round\" stroke-linejoin=\"round\" data-v-8e6699aa><path stroke=\"none\" d=\"M0 0h24v24H0z\" data-v-8e6699aa></path><path d=\"M9 5H7a2 2 0 0 0 -2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2 -2V7a2 2 0 0 0 -2 -2h-2\" data-v-8e6699aa></path><rect x=\"9\" y=\"3\" width=\"6\" height=\"4\" rx=\"2\" data-v-8e6699aa></rect><path d=\"M9 14l2 2l4 -4\" data-v-8e6699aa></path></svg></span>", 1)
const _hoisted_66 = { class: "flex flex-col ml-2" }
const _hoisted_67 = { class: "text-xs uppercase text-gray-500" }
const _hoisted_68 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("svg", {
    class: "h-5 w-5 text-primary",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, [
    /*#__PURE__*/_createElementVNode("polyline", { points: "1 4 1 10 7 10" }),
    /*#__PURE__*/_createElementVNode("polyline", { points: "23 20 23 14 17 14" }),
    /*#__PURE__*/_createElementVNode("path", { d: "M20.49 9A9 9 0 0 0 5.64 5.64L1 10m22 4l-4.64 4.36A9 9 0 0 1 3.51 15" })
  ])
], -1))
const _hoisted_69 = [
  _hoisted_68
]
const _hoisted_70 = {
  key: 1,
  class: "w-full"
}
const _hoisted_71 = { class: "mt-4 mb-3" }
const _hoisted_72 = { class: "stepper-section-title flex flex-row" }
const _hoisted_73 = /*#__PURE__*/_createTextVNode(" Other document ")
const _hoisted_74 = { class: "pl-1 pt-1" }
const _hoisted_75 = { key: 0 }
const _hoisted_76 = { class: "relative p-3 bg-gray-100 flex flex-row items-center rounded-lg" }
const _hoisted_77 = /*#__PURE__*/_createStaticVNode("<span data-v-8e6699aa><svg class=\"h-8 w-8 text-primary\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" stroke-width=\"2\" stroke=\"currentColor\" fill=\"none\" stroke-linecap=\"round\" stroke-linejoin=\"round\" data-v-8e6699aa><path stroke=\"none\" d=\"M0 0h24v24H0z\" data-v-8e6699aa></path><path d=\"M9 5H7a2 2 0 0 0 -2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2 -2V7a2 2 0 0 0 -2 -2h-2\" data-v-8e6699aa></path><rect x=\"9\" y=\"3\" width=\"6\" height=\"4\" rx=\"2\" data-v-8e6699aa></rect><path d=\"M9 14l2 2l4 -4\" data-v-8e6699aa></path></svg></span>", 1)
const _hoisted_78 = { class: "flex flex-col ml-2" }
const _hoisted_79 = { class: "text-xs uppercase text-gray-500" }
const _hoisted_80 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("svg", {
    class: "h-5 w-5 text-primary",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, [
    /*#__PURE__*/_createElementVNode("polyline", { points: "1 4 1 10 7 10" }),
    /*#__PURE__*/_createElementVNode("polyline", { points: "23 20 23 14 17 14" }),
    /*#__PURE__*/_createElementVNode("path", { d: "M20.49 9A9 9 0 0 0 5.64 5.64L1 10m22 4l-4.64 4.36A9 9 0 0 1 3.51 15" })
  ])
], -1))
const _hoisted_81 = [
  _hoisted_80
]
const _hoisted_82 = {
  key: 1,
  class: "w-full"
}
const _hoisted_83 = { class: "mt-4 mb-3" }
const _hoisted_84 = { class: "flex flex-row stepper-section-title" }
const _hoisted_85 = /*#__PURE__*/_createTextVNode(" Link ")
const _hoisted_86 = { class: "pl-1 pt-1" }
const _hoisted_87 = { class: "flex flex-col" }
const _hoisted_88 = { class: "w-full" }
const _hoisted_89 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "stepper-title" }, "Skills", -1))
const _hoisted_90 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("div", { class: "stepper-section-title" }, "Skills")
], -1))
const _hoisted_91 = { class: "flex flex-row flex-wrap" }
const _hoisted_92 = ["onClick"]
const _hoisted_93 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  "stroke-width": "1.5",
  stroke: "currentColor",
  class: "w-6 h-6 text-cyan-500 ml-2"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    d: "M12 6v12m6-6H6"
  })
], -1))
const _hoisted_94 = ["onClick"]
const _hoisted_95 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  "stroke-width": "1.5",
  stroke: "currentColor",
  class: "w-6 h-6 text-cyan-500 ml-2"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    d: "M12 6v12m6-6H6"
  })
], -1))
const _hoisted_96 = {
  key: 0,
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  "stroke-width": "1.5",
  stroke: "currentColor",
  class: "w-6 h-6"
}
const _hoisted_97 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  d: "M12 6v12m6-6H6"
}, null, -1))
const _hoisted_98 = [
  _hoisted_97
]
const _hoisted_99 = {
  key: 1,
  class: "w-6 h-6 mr-2",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}
const _hoisted_100 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("line", {
  x1: "5",
  y1: "12",
  x2: "19",
  y2: "12"
}, null, -1))
const _hoisted_101 = [
  _hoisted_100
]
const _hoisted_102 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "stepper-title" }, "Preferences", -1))
const _hoisted_103 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("div", { class: "stepper-section-title" }, "Expected salary")
], -1))
const _hoisted_104 = { class: "flex flex-col lg:flex-row justify-between items-center lg:space-x-12 space-y-3 lg:space-y-0 mt-6" }
const _hoisted_105 = { class: "w-full" }
const _hoisted_106 = { class: "w-full" }
const _hoisted_107 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mt-12" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "stepper-section-title" }, "Preferred work type")
], -1))
const _hoisted_108 = { class: "flex flex-row justify-between mt-6" }
const _hoisted_109 = { class: "flex flex-row justify-end px-4 py-4 mt-5" }
const _hoisted_110 = { class: "mr-3" }
const _hoisted_111 = ["disabled"]
const _hoisted_112 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "h-6 w-6 text-primary",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, [
  /*#__PURE__*/_createElementVNode("line", {
    x1: "19",
    y1: "12",
    x2: "5",
    y2: "12"
  }),
  /*#__PURE__*/_createElementVNode("polyline", { points: "12 19 5 12 12 5" })
], -1))
const _hoisted_113 = /*#__PURE__*/_createTextVNode(" Previous ")
const _hoisted_114 = [
  _hoisted_112,
  _hoisted_113
]
const _hoisted_115 = /*#__PURE__*/_createTextVNode(" Continue ")
const _hoisted_116 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "h-6 w-6 text-primary",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "#ffffff",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, [
  /*#__PURE__*/_createElementVNode("line", {
    x1: "5",
    y1: "12",
    x2: "19",
    y2: "12"
  }),
  /*#__PURE__*/_createElementVNode("polyline", { points: "12 19 19 12 12 5" })
], -1))
const _hoisted_117 = [
  _hoisted_115,
  _hoisted_116
]
const _hoisted_118 = /*#__PURE__*/_createTextVNode(" Submit application ")
const _hoisted_119 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "h-6 w-6 mr-2 text-primary",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "#ffffff",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, [
  /*#__PURE__*/_createElementVNode("line", {
    x1: "5",
    y1: "12",
    x2: "19",
    y2: "12"
  }),
  /*#__PURE__*/_createElementVNode("polyline", { points: "12 19 19 12 12 5" })
], -1))
const _hoisted_120 = [
  _hoisted_118,
  _hoisted_119
]
const _hoisted_121 = ["disabled"]
const _hoisted_122 = {
  key: 0,
  class: "h-6 w-6 text-primary ml-2",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "#ffffff",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}
const _hoisted_123 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("line", {
  x1: "5",
  y1: "12",
  x2: "19",
  y2: "12"
}, null, -1))
const _hoisted_124 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("polyline", { points: "12 19 19 12 12 5" }, null, -1))
const _hoisted_125 = [
  _hoisted_123,
  _hoisted_124
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Loader = _resolveComponent("Loader")!
  const _component_TextField = _resolveComponent("TextField")!
  const _component_AutocompleteLocation = _resolveComponent("AutocompleteLocation")!
  const _component_TextArea = _resolveComponent("TextArea")!
  const _component_WorkExperienceArrayField = _resolveComponent("WorkExperienceArrayField")!
  const _component_EducationArrayField = _resolveComponent("EducationArrayField")!
  const _component_DragAndDropFile = _resolveComponent("DragAndDropFile")!
  const _component_Tooltip = _resolveComponent("Tooltip")!
  const _component_Chips = _resolveComponent("Chips")!
  const _component_CurrencyField = _resolveComponent("CurrencyField")!
  const _component_DropDown = _resolveComponent("DropDown")!
  const _component_CheckBoxGroup = _resolveComponent("CheckBoxGroup")!
  const _component_ApplyJobFormSummary = _resolveComponent("ApplyJobFormSummary")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    (_ctx.isLoadingData && !_ctx.job.id)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_Loader)
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("button", {
                  type: "button",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('jobInfo'))),
                  class: "flex flex-row text-primary justify-center items-center px-4 py-2 rounded-3xl transition-colors text-xs lg:text-base mr-2"
                }, _hoisted_8),
                (_ctx.job.title)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_9, " You are applying to: " + _toDisplayString(_ctx.job?.title), 1))
                  : _createCommentVNode("", true),
                (_ctx.$route.name === 'CandidateOnboarding')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_10, " Complete your information "))
                  : _createCommentVNode("", true),
                (_ctx.$route.name === 'Edit Candidate')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_11, " Update your information "))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("button", {
                    type: "button",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.changeStep('previous'))),
                    disabled: _ctx.isLoadingButton,
                    class: _normalizeClass(["flex flex-row text-primary justify-center items-center px-4 py-2 rounded-3xl transition-colors text-xs lg:text-base bg-gray-300 disabled:opacity-50 disabled:cursor-not-allowed disabled:bg-black", { hidden: _ctx.step === 1 }])
                  }, _hoisted_17, 10, _hoisted_14)
                ]),
                _createElementVNode("div", null, [
                  _withDirectives(_createElementVNode("button", {
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.changeStep('next'))),
                    class: "flex flex-row text-white justify-center items-center px-4 py-2 rounded-3xl transition-colors text-xs lg:text-base bg-primary",
                    type: "button"
                  }, _hoisted_20, 512), [
                    [_vShow, _ctx.step !== 4]
                  ])
                ]),
                _withDirectives(_createElementVNode("div", null, [
                  (_ctx.$route.name === 'CandidateOnboarding')
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        type: "submit",
                        class: "flex flex-row text-white justify-center items-center px-4 py-2 rounded-3xl transition-colors text-xs lg:text-base bg-primary disabled:opacity-50 disabled:cursor-not-allowed disabled:bg-black",
                        onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onSubmit && _ctx.onSubmit(...args))),
                        disabled: _ctx.isLoadingButton
                      }, [
                        _createTextVNode(_toDisplayString(_ctx.isLoadingButton
                  ? "Submitting application"
                  : "Submit application") + " ", 1),
                        (!_ctx.isLoadingButton)
                          ? (_openBlock(), _createElementBlock("svg", _hoisted_22, _hoisted_25))
                          : _createCommentVNode("", true)
                      ], 8, _hoisted_21))
                    : (_openBlock(), _createElementBlock("button", {
                        key: 1,
                        type: "submit",
                        class: "flex flex-row text-white justify-center items-center px-4 py-2 rounded-3xl transition-colors text-xs lg:text-base bg-primary disabled:opacity-50 disabled:cursor-not-allowed disabled:bg-black",
                        disabled: _ctx.isLoadingButton,
                        onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.onSubmit && _ctx.onSubmit(...args)))
                      }, [
                        _createTextVNode(_toDisplayString(_ctx.isLoadingButton ? "Saving" : "Finish") + " ", 1),
                        (!_ctx.isLoadingButton)
                          ? (_openBlock(), _createElementBlock("svg", _hoisted_27, _hoisted_30))
                          : _createCommentVNode("", true)
                      ], 8, _hoisted_26))
                ], 512), [
                  [_vShow, _ctx.step === 4]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_31, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.stepStages, (item, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "text-center p-2 transition-all transition-1000 delay-300",
                  key: `step-${index}`
                }, [
                  _createElementVNode("div", _hoisted_32, [
                    _createElementVNode("div", {
                      class: _normalizeClass(["text-center space-y-2 px-4 py-4 sm:text-left rounded-lg transition-all ease-in-out delay-100", {
                'bg-primary-light border-2 border-purple-100 shadow-lg transition-all ease-in-out delay-100 -translate-y-1':
                  _ctx.step == item.number,
              }])
                    }, [
                      _createElementVNode("div", _hoisted_33, [
                        _createElementVNode("div", _hoisted_34, [
                          _createElementVNode("span", _hoisted_35, _toDisplayString(item.number), 1),
                          _createElementVNode("span", _hoisted_36, _toDisplayString(item.title), 1)
                        ]),
                        _createElementVNode("p", _hoisted_37, _toDisplayString(item.description), 1)
                      ])
                    ], 2)
                  ])
                ]))
              }), 128))
            ])
          ]),
          _createElementVNode("div", _hoisted_38, [
            _createElementVNode("div", {
              class: _normalizeClass({ hidden: _ctx.step !== 1 })
            }, [
              _hoisted_39,
              _createElementVNode("form", {
                onSubmit: _cache[15] || (_cache[15] = 
//@ts-ignore
(...args) => (_ctx.onSubmit && _ctx.onSubmit(...args)))
              }, [
                _createElementVNode("div", null, [
                  _hoisted_40,
                  _createElementVNode("div", _hoisted_41, [
                    _createElementVNode("div", _hoisted_42, [
                      _hoisted_43,
                      _createVNode(_component_TextField, {
                        modelValue: _ctx.first_name,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.first_name) = $event)),
                        label: "",
                        placeholder: "First name",
                        typeInput: "text",
                        name: "first_name",
                        board: true
                      }, null, 8, ["modelValue"])
                    ]),
                    _createElementVNode("div", _hoisted_44, [
                      _hoisted_45,
                      _createVNode(_component_TextField, {
                        modelValue: _ctx.last_name,
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.last_name) = $event)),
                        label: "",
                        typeInput: "text",
                        placeholder: "Last name",
                        name: "last_name",
                        board: true
                      }, null, 8, ["modelValue"])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_46, [
                    _createElementVNode("div", _hoisted_47, [
                      _hoisted_48,
                      _createVNode(_component_TextField, {
                        modelValue: _ctx.email,
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.email) = $event)),
                        label: "",
                        placeholder: "Email",
                        typeInput: "text",
                        name: "email",
                        board: true,
                        disabled: _ctx.isEditing
                      }, null, 8, ["modelValue", "disabled"])
                    ]),
                    _createElementVNode("div", _hoisted_49, [
                      _hoisted_50,
                      _createVNode(_component_TextField, {
                        modelValue: _ctx.phone,
                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.phone) = $event)),
                        label: "",
                        placeholder: "Phone",
                        typeInput: "text",
                        name: "phone",
                        board: true,
                        maxlength: "10"
                      }, null, 8, ["modelValue"])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_51, [
                    _createElementVNode("div", _hoisted_52, [
                      _hoisted_53,
                      _createElementVNode("div", _hoisted_54, [
                        _createVNode(_component_AutocompleteLocation, {
                          "onUpdate:modelValue": _ctx.updateHandler,
                          locationName: _ctx.locationName
                        }, null, 8, ["onUpdate:modelValue", "locationName"])
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", null, [
                  _hoisted_55,
                  _createElementVNode("div", _hoisted_56, [
                    _hoisted_57,
                    _createElementVNode("div", _hoisted_58, [
                      _createVNode(_component_TextArea, {
                        modelValue: _ctx.summary,
                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.summary) = $event)),
                        label: "Write here",
                        rows: "4",
                        className: "pt-5 pb-2 pl-4 pr-10 block w-full px-0 mt-0 bg-transparent border-2 rounded-lg border-solid appearance-none focus:outline-none focus:ring-0 focus:border-gray-200 border-gray-200",
                        isLabel: false,
                        placeholder: "Write here",
                        name: "summary"
                      }, null, 8, ["modelValue"])
                    ])
                  ])
                ]),
                _createElementVNode("div", null, [
                  _createElementVNode("div", _hoisted_59, [
                    _createVNode(_component_WorkExperienceArrayField, { industries: _ctx.industries }, null, 8, ["industries"])
                  ])
                ]),
                _createElementVNode("div", null, [
                  _hoisted_60,
                  _createElementVNode("div", _hoisted_61, [
                    _createVNode(_component_EducationArrayField)
                  ])
                ]),
                _createElementVNode("div", null, [
                  _hoisted_62,
                  _createElementVNode("div", null, [
                    (_ctx.auxFile)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_63, [
                          _createElementVNode("div", _hoisted_64, [
                            _hoisted_65,
                            _createElementVNode("div", _hoisted_66, [
                              _createElementVNode("span", null, _toDisplayString(_ctx.getFileName(_ctx.auxFile)), 1),
                              _createElementVNode("span", _hoisted_67, _toDisplayString(_ctx.getFileExtension(_ctx.auxFile)), 1)
                            ]),
                            _createElementVNode("div", {
                              class: "absolute right-4 cursor-pointer",
                              onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.setEmptyFile && _ctx.setEmptyFile(...args)))
                            }, _hoisted_69)
                          ])
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_70, [
                          _createVNode(_component_DragAndDropFile, {
                            modelValue: _ctx.fileResume,
                            "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.fileResume) = $event)),
                            placeholder: "You can upload PDF or DOC/XLS. The maxmimum file size of file is 5MB.",
                            label: "Drag and drop your file here",
                            fileTypes: ".doc,.docx,application/msword,application/vnd.ms-excel,application/pdf",
                            onSetFileName: _ctx.setFileNameResume
                          }, null, 8, ["modelValue", "onSetFileName"])
                        ]))
                  ])
                ]),
                _createElementVNode("div", null, [
                  _createElementVNode("div", _hoisted_71, [
                    _createElementVNode("div", _hoisted_72, [
                      _hoisted_73,
                      _createElementVNode("div", _hoisted_74, [
                        _createVNode(_component_Tooltip, { message: "You can upload another document such as a cover letter to help us understand your background and qualifications better." })
                      ])
                    ])
                  ]),
                  _createElementVNode("div", null, [
                    (_ctx.auxOtherFile)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_75, [
                          _createElementVNode("div", _hoisted_76, [
                            _hoisted_77,
                            _createElementVNode("div", _hoisted_78, [
                              _createElementVNode("span", null, _toDisplayString(_ctx.getFileName(_ctx.auxOtherFile)), 1),
                              _createElementVNode("span", _hoisted_79, _toDisplayString(_ctx.getFileExtension(_ctx.auxOtherFile)), 1)
                            ]),
                            _createElementVNode("div", {
                              class: "absolute right-4 cursor-pointer",
                              onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.auxOtherFile = ''))
                            }, _hoisted_81)
                          ])
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_82, [
                          _createVNode(_component_DragAndDropFile, {
                            modelValue: _ctx.fileOther,
                            "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.fileOther) = $event)),
                            placeholder: "You can upload PDF or DOC/XLS. The maxmimum file size of file is 5MB.",
                            label: "Drag and drop your file here",
                            fileTypes: ".xlsx,.doc,.docx,application/msword,application/vnd.ms-excel,application/pdf",
                            onSetFileName: _ctx.setFileNameOther
                          }, null, 8, ["modelValue", "onSetFileName"])
                        ]))
                  ])
                ]),
                _createElementVNode("div", null, [
                  _createElementVNode("div", _hoisted_83, [
                    _createElementVNode("div", _hoisted_84, [
                      _hoisted_85,
                      _createElementVNode("div", _hoisted_86, [
                        _createVNode(_component_Tooltip, { message: "You can include your blog, portfolio, Github, social media profiles and any other links that show information relevant to your application." })
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_87, [
                    _createElementVNode("div", _hoisted_88, [
                      _createVNode(_component_TextField, {
                        modelValue: _ctx.link,
                        "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.link) = $event)),
                        label: "",
                        placeholder: "Link",
                        typeInput: "text",
                        name: "link",
                        board: true
                      }, null, 8, ["modelValue"])
                    ])
                  ])
                ])
              ], 32)
            ], 2),
            _createElementVNode("div", {
              class: _normalizeClass({ hidden: _ctx.step !== 2 })
            }, [
              _hoisted_89,
              _createElementVNode("div", null, [
                _hoisted_90,
                _createVNode(_component_Chips, {
                  chips: _ctx.selectedSkills,
                  placeholder: "New skill",
                  class: "mt-2"
                }, null, 8, ["chips"]),
                _createElementVNode("div", _hoisted_91, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.visibleSkills, (skill, i) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: i,
                      class: "flex flex-row items-center skill p-2 m-2 rounded hover:cursor-pointer",
                      onClick: ($event: any) => (_ctx.pushToSelectedSkills(skill.name))
                    }, [
                      _createTextVNode(_toDisplayString(skill.name) + " ", 1),
                      _hoisted_93
                    ], 8, _hoisted_92))
                  }), 128)),
                  (_ctx.showMoreSkills)
                    ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.hiddenSkills, (skill, i) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: i,
                          class: "flex flex-row items-center skill p-2 m-2 rounded hover:cursor-pointer",
                          onClick: ($event: any) => (_ctx.pushToSelectedSkills(skill.name))
                        }, [
                          _createTextVNode(_toDisplayString(skill.name) + " ", 1),
                          _hoisted_95
                        ], 8, _hoisted_94))
                      }), 128))
                    : _createCommentVNode("", true),
                  _createElementVNode("button", {
                    type: "button",
                    onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.showHiddenSkills())),
                    class: "flex flex-row text-primary font-bold items-center"
                  }, [
                    (!_ctx.showMoreSkills)
                      ? (_openBlock(), _createElementBlock("svg", _hoisted_96, _hoisted_98))
                      : (_openBlock(), _createElementBlock("svg", _hoisted_99, _hoisted_101)),
                    _createTextVNode(" " + _toDisplayString(_ctx.showMoreSkills ? "View less" : "View more"), 1)
                  ])
                ])
              ])
            ], 2),
            _createElementVNode("div", {
              class: _normalizeClass({ hidden: _ctx.step !== 3 })
            }, [
              _hoisted_102,
              _createElementVNode("div", null, [
                _createElementVNode("div", null, [
                  _hoisted_103,
                  _createElementVNode("div", _hoisted_104, [
                    _createElementVNode("div", _hoisted_105, [
                      _createVNode(_component_CurrencyField, {
                        modelValue: _ctx.currentSalary,
                        "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.currentSalary) = $event)),
                        label: "Salary per year",
                        name: "current_salary"
                      }, null, 8, ["modelValue"])
                    ]),
                    _createElementVNode("div", _hoisted_106, [
                      _createVNode(_component_DropDown, {
                        options: _ctx.optionCurrencies,
                        modelValue: _ctx.currencySalary,
                        "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.currencySalary) = $event)),
                        label: "Select currency...",
                        name: "salary_currency"
                      }, null, 8, ["options", "modelValue"])
                    ])
                  ])
                ]),
                _createElementVNode("div", null, [
                  _hoisted_107,
                  _createElementVNode("div", _hoisted_108, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.workTypes, (item, index) => {
                      return (_openBlock(), _createBlock(_component_CheckBoxGroup, {
                        key: `work-type${index}`,
                        fieldId: item.label,
                        names: _ctx.preferred_work_types,
                        "onUpdate:names": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.preferred_work_types) = $event)),
                        label: item.label,
                        value: item.value
                      }, null, 8, ["fieldId", "names", "label", "value"]))
                    }), 128))
                  ])
                ])
              ])
            ], 2),
            _createElementVNode("div", {
              class: _normalizeClass([{ hidden: _ctx.step !== 4 }, ""])
            }, [
              _createVNode(_component_ApplyJobFormSummary, {
                job: _ctx.job,
                form: _ctx.values,
                skills: _ctx.selectedSkills,
                candidate_location: _ctx.candidate_location,
                workType: _ctx.preferred_work_types,
                fileResume: _ctx.fileResume ? _ctx.fileResume : _ctx.auxFile,
                fileOther: _ctx.fileOther ? _ctx.fileOther : _ctx.auxOtherFile,
                onChangeStep: _ctx.setStep
              }, null, 8, ["job", "form", "skills", "candidate_location", "workType", "fileResume", "fileOther", "onChangeStep"])
            ], 2),
            _createElementVNode("div", _hoisted_109, [
              _createElementVNode("div", _hoisted_110, [
                _createElementVNode("button", {
                  type: "button",
                  onClick: _cache[20] || (_cache[20] = ($event: any) => (_ctx.changeStep('previous'))),
                  class: _normalizeClass(["flex flex-row text-primary justify-center items-center px-4 py-2 rounded-3xl transition-colors text-xs lg:text-base bg-gray-300 disabled:opacity-50 disabled:cursor-not-allowed disabled:bg-black", { hidden: _ctx.step === 1 }]),
                  disabled: _ctx.isLoadingButton
                }, _hoisted_114, 10, _hoisted_111)
              ]),
              _createElementVNode("div", null, [
                _withDirectives(_createElementVNode("button", {
                  onClick: _cache[21] || (_cache[21] = ($event: any) => (_ctx.changeStep('next'))),
                  class: "flex flex-row text-white justify-center items-center px-4 py-2 rounded-3xl transition-colors text-xs lg:text-base bg-primary",
                  type: "button"
                }, _hoisted_117, 512), [
                  [_vShow, _ctx.step !== 4]
                ])
              ]),
              _withDirectives(_createElementVNode("div", null, [
                (_ctx.$route.name === 'CandidateOnboarding')
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      type: "submit",
                      class: "flex flex-row text-white justify-center items-center px-4 py-2 rounded-3xl transition-colors text-xs lg:text-base bg-primary",
                      onClick: _cache[22] || (_cache[22] = 
//@ts-ignore
(...args) => (_ctx.onSubmit && _ctx.onSubmit(...args)))
                    }, _hoisted_120))
                  : (_openBlock(), _createElementBlock("button", {
                      key: 1,
                      type: "submit",
                      class: "flex flex-row text-white justify-center items-center px-4 py-2 rounded-3xl transition-colors text-xs lg:text-base bg-primary disabled:opacity-50 disabled:cursor-not-allowed",
                      disabled: _ctx.isLoadingButton,
                      onClick: _cache[23] || (_cache[23] = 
//@ts-ignore
(...args) => (_ctx.onSubmit && _ctx.onSubmit(...args)))
                    }, [
                      _createTextVNode(_toDisplayString(_ctx.isLoadingButton ? "Saving" : "Finish") + " ", 1),
                      (!_ctx.isLoadingButton)
                        ? (_openBlock(), _createElementBlock("svg", _hoisted_122, _hoisted_125))
                        : _createCommentVNode("", true)
                    ], 8, _hoisted_121))
              ], 512), [
                [_vShow, _ctx.step === 4]
              ])
            ])
          ])
        ]))
  ], 64))
}